import React, { useState, useEffect, useCallback } from 'react';
import { DERS_AILELERI } from '../lib/dersler';

// Ders-bazlı kullanıcı yönetimi paneli (2026-06-21).
// super_admin/admin kullanıcı oluşturur, ders atar (aile bazlı), aktif/pasif eder.
// Backend: GET/POST /api/auth/kayit, GET /api/auth/kullanicilar, PATCH /api/auth/kullanicilar/:id

const ROL_ETIKET = { ogretmen: 'Öğretmen', admin: 'Admin', super_admin: 'Süper Admin' };

// Seçili ders ailesi key'lerinden ders DEĞERLERİ dizisi üret (izinli_dersler için).
function ailelerdenDersler(aileKeyler) {
  const set = new Set();
  DERS_AILELERI.forEach((a) => {
    if (aileKeyler.includes(a.key)) a.dersDegerleri.forEach((d) => set.add(d));
  });
  return [...set];
}

// izinli_dersler (ders değerleri) -> kapsadığı ders ailesi key'leri (display için).
function derslerdenAileler(izinliDersler) {
  if (!Array.isArray(izinliDersler) || izinliDersler.length === 0) return [];
  const izin = new Set(izinliDersler);
  return DERS_AILELERI.filter((a) => a.dersDegerleri.some((d) => izin.has(d))).map((a) => a.key);
}

export default function Kullanicilar({ apiUrl, authFetch, rolYeterli, onGeri }) {
  const [liste, setListe] = useState([]);
  const [yukleniyor, setYukleniyor] = useState(true);
  const [hata, setHata] = useState('');
  const [bilgi, setBilgi] = useState('');

  const superAdmin = rolYeterli('super_admin');

  // Yeni kullanıcı formu
  const [form, setForm] = useState({ ad: '', kullanici_adi: '', email: '', sifre: '', rol: 'ogretmen', aileler: [] });

  // Düzenleme satırı
  const [duzenleId, setDuzenleId] = useState(null);
  const [duzenle, setDuzenle] = useState({ rol: 'ogretmen', aileler: [], aktif: true, sifre: '' });

  const yukle = useCallback(async () => {
    setYukleniyor(true); setHata('');
    try {
      const r = await authFetch(`${apiUrl}/api/auth/kullanicilar`);
      if (!r.ok) throw new Error('Liste alınamadı (yetki?)');
      setListe(await r.json());
    } catch (e) {
      setHata(e.message || 'Hata');
    }
    setYukleniyor(false);
  }, [apiUrl, authFetch]);

  useEffect(() => { yukle(); }, [yukle]);

  const aileToggle = (kaynak, setKaynak, key) => {
    const v = kaynak.aileler.includes(key)
      ? kaynak.aileler.filter((k) => k !== key)
      : [...kaynak.aileler, key];
    setKaynak({ ...kaynak, aileler: v });
  };

  const olustur = async (e) => {
    e.preventDefault();
    setHata(''); setBilgi('');
    if (!form.ad || !form.sifre || (!form.kullanici_adi && !form.email)) {
      setHata('Ad, şifre ve (kullanıcı adı veya e-posta) zorunlu'); return;
    }
    try {
      const r = await authFetch(`${apiUrl}/api/auth/kayit`, {
        method: 'POST',
        body: JSON.stringify({
          ad: form.ad,
          kullanici_adi: form.kullanici_adi || null,
          email: form.email || null,
          sifre: form.sifre,
          rol: form.rol,
          izinli_dersler: ailelerdenDersler(form.aileler),
        }),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.hata || 'Oluşturma başarısız');
      setBilgi(`Kullanıcı oluşturuldu: ${form.kullanici_adi || form.email}`);
      setForm({ ad: '', kullanici_adi: '', email: '', sifre: '', rol: 'ogretmen', aileler: [] });
      yukle();
    } catch (e) {
      setHata(e.message);
    }
  };

  const duzenleBaslat = (k) => {
    setDuzenleId(k.id);
    setDuzenle({ rol: k.rol, aileler: derslerdenAileler(k.izinli_dersler), aktif: k.aktif, sifre: '' });
    setHata(''); setBilgi('');
  };

  const duzenleKaydet = async (id) => {
    setHata(''); setBilgi('');
    try {
      const govde = {
        rol: duzenle.rol,
        izinli_dersler: ailelerdenDersler(duzenle.aileler),
        aktif: duzenle.aktif,
      };
      if (duzenle.sifre) govde.sifre = duzenle.sifre;
      const r = await authFetch(`${apiUrl}/api/auth/kullanicilar/${id}`, {
        method: 'PATCH',
        body: JSON.stringify(govde),
      });
      const d = await r.json();
      if (!r.ok) throw new Error(d.hata || 'Güncelleme başarısız');
      setBilgi('Kullanıcı güncellendi');
      setDuzenleId(null);
      yukle();
    } catch (e) {
      setHata(e.message);
    }
  };

  const rolSecenekleri = ['ogretmen', ...(superAdmin ? ['admin', 'super_admin'] : [])];

  // Ders ailesi checkbox grubu (oluştur + düzenle ortak)
  const AileSecici = ({ secili, onToggle }) => (
    <div className="flex flex-wrap gap-1.5">
      {DERS_AILELERI.map((a) => {
        const aktif = secili.includes(a.key);
        return (
          <button type="button" key={a.key} onClick={() => onToggle(a.key)}
            className={`px-2 py-1 rounded text-xs border transition-colors ${aktif ? 'text-white border-transparent' : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'}`}
            style={aktif ? { backgroundColor: a.renk } : {}}
            title={a.aktif ? a.label : `${a.label} (yakında — soru henüz yok)`}>
            {a.ikon} {a.label}{!a.aktif && ' ·'}
          </button>
        );
      })}
    </div>
  );

  return (
    <div className="max-w-5xl mx-auto">
      <div className="flex items-center gap-3 mb-5">
        <button onClick={onGeri} className="px-3 py-1.5 text-xs border border-gray-300 rounded-lg hover:bg-gray-50">← Geri</button>
        <h2 className="text-lg font-bold text-gray-800">👤 Kullanıcı Yönetimi</h2>
      </div>

      {hata && <div className="mb-3 p-3 bg-red-50 border border-red-300 rounded-lg text-red-700 text-sm">{hata}</div>}
      {bilgi && <div className="mb-3 p-3 bg-green-50 border border-green-300 rounded-lg text-green-700 text-sm">{bilgi}</div>}

      {/* YENİ KULLANICI */}
      <form onSubmit={olustur} className="bg-white border border-gray-200 rounded-xl p-4 mb-6 shadow-sm">
        <div className="text-sm font-semibold text-gray-700 mb-3">Yeni Kullanıcı</div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-2 mb-3">
          <input value={form.ad} onChange={(e) => setForm({ ...form, ad: e.target.value })}
            placeholder="Ad Soyad" className="px-3 py-2 border border-gray-300 rounded text-sm" />
          <input value={form.kullanici_adi} onChange={(e) => setForm({ ...form, kullanici_adi: e.target.value })}
            placeholder="Kullanıcı adı (TurUser)" className="px-3 py-2 border border-gray-300 rounded text-sm" />
          <input value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })}
            placeholder="E-posta (opsiyonel)" className="px-3 py-2 border border-gray-300 rounded text-sm" />
          <input type="password" value={form.sifre} onChange={(e) => setForm({ ...form, sifre: e.target.value })}
            placeholder="Şifre" autoComplete="new-password" className="px-3 py-2 border border-gray-300 rounded text-sm" />
        </div>
        <div className="flex flex-wrap items-center gap-4 mb-3">
          <label className="text-xs text-gray-600 flex items-center gap-1.5">
            Rol:
            <select value={form.rol} onChange={(e) => setForm({ ...form, rol: e.target.value })}
              className="px-2 py-1.5 border border-gray-300 rounded text-xs bg-white">
              {rolSecenekleri.map((r) => <option key={r} value={r}>{ROL_ETIKET[r]}</option>)}
            </select>
          </label>
        </div>
        <div className="mb-2 text-xs text-gray-500">Görebileceği dersler (hiç seçilmezse <b>tüm derslere</b> erişir):</div>
        <AileSecici secili={form.aileler} onToggle={(k) => aileToggle(form, setForm, k)} />
        <div className="mt-4">
          <button type="submit" className="px-4 py-2 bg-blue-600 text-white text-sm font-semibold rounded-lg hover:bg-blue-700">Oluştur</button>
        </div>
      </form>

      {/* LİSTE */}
      <div className="bg-white border border-gray-200 rounded-xl overflow-hidden shadow-sm">
        <div className="px-4 py-2.5 text-sm font-semibold text-gray-700 border-b border-gray-100 flex justify-between items-center">
          <span>Kullanıcılar ({liste.length})</span>
          <button onClick={yukle} className="text-xs text-blue-600 hover:underline">Yenile</button>
        </div>
        {yukleniyor ? (
          <div className="p-6 text-center text-gray-400 text-sm">Yükleniyor…</div>
        ) : (
          <table className="w-full text-sm">
            <thead className="bg-gray-50 text-gray-500 text-xs">
              <tr>
                <th className="text-left px-3 py-2 font-semibold">Ad</th>
                <th className="text-left px-3 py-2 font-semibold">Kullanıcı / E-posta</th>
                <th className="text-left px-3 py-2 font-semibold">Rol</th>
                <th className="text-left px-3 py-2 font-semibold">Dersler</th>
                <th className="text-left px-3 py-2 font-semibold">Durum</th>
                <th className="text-right px-3 py-2 font-semibold">İşlem</th>
              </tr>
            </thead>
            <tbody>
              {liste.map((k) => {
                const aileler = derslerdenAileler(k.izinli_dersler);
                const duzenleniyor = duzenleId === k.id;
                return (
                  <React.Fragment key={k.id}>
                    <tr className="border-t border-gray-100">
                      <td className="px-3 py-2 font-medium text-gray-800">{k.ad}</td>
                      <td className="px-3 py-2 text-gray-600">
                        <div>{k.kullanici_adi || <span className="text-gray-300">—</span>}</div>
                        <div className="text-[11px] text-gray-400">{k.email}</div>
                      </td>
                      <td className="px-3 py-2">
                        <span className={`px-1.5 py-0.5 rounded text-[11px] font-semibold ${k.rol === 'super_admin' ? 'bg-purple-100 text-purple-700' : k.rol === 'admin' ? 'bg-blue-100 text-blue-700' : 'bg-gray-100 text-gray-600'}`}>{ROL_ETIKET[k.rol] || k.rol}</span>
                      </td>
                      <td className="px-3 py-2">
                        {aileler.length === 0
                          ? <span className="text-[11px] text-gray-400 italic">Tüm dersler</span>
                          : <div className="flex flex-wrap gap-1">{aileler.map((ak) => {
                              const a = DERS_AILELERI.find((x) => x.key === ak);
                              return <span key={ak} className="px-1.5 py-0.5 rounded text-[10px] text-white font-semibold" style={{ backgroundColor: a?.renk || '#777' }}>{a?.kisaAd || ak}</span>;
                            })}</div>}
                      </td>
                      <td className="px-3 py-2">
                        <span className={`px-1.5 py-0.5 rounded text-[11px] font-semibold ${k.aktif ? 'bg-green-100 text-green-700' : 'bg-red-100 text-red-600'}`}>{k.aktif ? 'Aktif' : 'Pasif'}</span>
                      </td>
                      <td className="px-3 py-2 text-right">
                        <button onClick={() => (duzenleniyor ? setDuzenleId(null) : duzenleBaslat(k))}
                          className="text-xs text-blue-600 hover:underline">{duzenleniyor ? 'Kapat' : 'Düzenle'}</button>
                      </td>
                    </tr>
                    {duzenleniyor && (
                      <tr className="bg-blue-50/40 border-t border-blue-100">
                        <td colSpan={6} className="px-4 py-3">
                          <div className="flex flex-wrap items-center gap-4 mb-3">
                            <label className="text-xs text-gray-600 flex items-center gap-1.5">
                              Rol:
                              <select value={duzenle.rol} onChange={(e) => setDuzenle({ ...duzenle, rol: e.target.value })}
                                className="px-2 py-1.5 border border-gray-300 rounded text-xs bg-white">
                                {rolSecenekleri.map((r) => <option key={r} value={r}>{ROL_ETIKET[r]}</option>)}
                              </select>
                            </label>
                            <label className="text-xs text-gray-600 flex items-center gap-1.5">
                              <input type="checkbox" checked={duzenle.aktif} onChange={(e) => setDuzenle({ ...duzenle, aktif: e.target.checked })} />
                              Aktif
                            </label>
                            <label className="text-xs text-gray-600 flex items-center gap-1.5">
                              Yeni şifre:
                              <input type="password" value={duzenle.sifre} onChange={(e) => setDuzenle({ ...duzenle, sifre: e.target.value })}
                                placeholder="(değiştirme)" autoComplete="new-password" className="px-2 py-1.5 border border-gray-300 rounded text-xs" />
                            </label>
                          </div>
                          <div className="mb-2 text-xs text-gray-500">Görebileceği dersler (hiç seçilmezse tüm derslere erişir):</div>
                          <AileSecici secili={duzenle.aileler} onToggle={(key) => aileToggle(duzenle, setDuzenle, key)} />
                          <div className="mt-3 flex gap-2">
                            <button onClick={() => duzenleKaydet(k.id)} className="px-3 py-1.5 bg-green-600 text-white text-xs font-semibold rounded hover:bg-green-700">Kaydet</button>
                            <button onClick={() => setDuzenleId(null)} className="px-3 py-1.5 border border-gray-300 text-xs rounded hover:bg-gray-50">İptal</button>
                          </div>
                        </td>
                      </tr>
                    )}
                  </React.Fragment>
                );
              })}
            </tbody>
          </table>
        )}
      </div>
    </div>
  );
}
